import { bl_applet_template_message_placeholder_hdr_RowClass } from '../../dbschema/bl_applet_template_message_placeholder_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class AppletTemplateMessagePlaceholderHdrContainer extends BaseContainerModel {
    bl_applet_template_message_placeholder_hdr: bl_applet_template_message_placeholder_hdr_RowClass = new bl_applet_template_message_placeholder_hdr_RowClass();
}


